// import React, { useEffect, useState } from "react";
// import PricingCard from "../Cart/PricingCard";
// import { Box, Button, Modal } from "@mui/material";
// import AddressForm from "./AddresssForm";
// import AddressCard from "./AddressCard";
// import AddIcon from "@mui/icons-material/Add";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import LockIcon from "@mui/icons-material/Lock";
// import SecurityIcon from "@mui/icons-material/Security";
// import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
// import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
// import { useNavigate } from "react-router-dom";

// import { createOrder } from "../../../Redux Toolkit/Customer/OrderSlice";
// import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
// import {
//   addUserAddress,
//   fetchUserAddresses,
// } from "../../../Redux Toolkit/Customer/UserSlice";
// import { Address } from "../../../types/userTypes";

// const style = {
//   position: "fixed" as const,
//   top: "52%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "calc(100% - 24px)",
//   maxWidth: "620px",
//   outline: "none",
//   bgcolor: "transparent",
//   boxShadow: "none",
//   p: 0,
//   overflow: "hidden",
// };

// const AddressPage = () => {
//   const dispatch = useAppDispatch();
//   const navigate = useNavigate();

//   const { user } = useAppSelector((store) => store);

//   // const addresses =
//   //   user.addresses && user.addresses.length > 0
//   //     ? user.addresses
//   //     : user.user?.addresses || [];

//   const addresses =
//     user.addresses && user.addresses.length > 0
//       ? user.addresses
//       : user.user?.addresses || [];

//   const defaultAddressIndex = addresses.findIndex(
//     (address: Address) => address.defaultAddress
//   );

//   const [value, setValue] = useState(
//     defaultAddressIndex >= 0 ? defaultAddressIndex : 0
//   );

//   const [paymentGateway] = useState("RAZORPAY");
//   const [open, setOpen] = useState(false);

//   useEffect(() => {
//     const jwt = localStorage.getItem("jwt") || "";

//     if (jwt) {
//       dispatch(fetchUserAddresses({ jwt }));
//     }
//   }, [dispatch]);

//   useEffect(() => {
//     const newDefaultAddressIndex = addresses.findIndex(
//       (address: Address) => address.defaultAddress
//     );

//     if (newDefaultAddressIndex >= 0) {
//       setValue(newDefaultAddressIndex);
//     } else if (addresses.length > 0 && value >= addresses.length) {
//       setValue(0);
//     }
//   }, [addresses, value]);

//   const handleOpen = () => {
//     setOpen(true);
//     document.body.style.overflow = "hidden";
//   };

//   const handleClose = () => {
//     setOpen(false);
//     document.body.style.overflow = "";
//   };

//   const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//     setValue(Number(event.target.value));
//   };

//   const handleCreateOrder = () => {
//     const selectedAddress = addresses[value];

//     if (!selectedAddress) return;

//     dispatch(
//       createOrder({
//         paymentGateway,
//         address: selectedAddress,
//         jwt: localStorage.getItem("jwt") || "",
//       })
//     );
//   };

//   const handleAddressSubmit = async (address: Address) => {
//     const jwt = localStorage.getItem("jwt") || "";

//     if (!jwt) return;

//     await dispatch(addUserAddress({ jwt, address }));
//     await dispatch(fetchUserAddresses({ jwt }));

//     handleClose();
//   };

//   return (
//     <div className="min-h-screen bg-white px-4 sm:px-8 lg:px-14 xl:px-20 py-7">
//       <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-[1500px] mx-auto">
//         <div className="lg:col-span-2">
          
//           <h1 className="text-lg font-semibold">
//             Select Delivery Address
//           </h1>
//           <p className="text-sm text-gray-600 mt-1 mb-6">
//             Choose an address to deliver your order
//           </p>

//           <button
//             onClick={handleOpen}
//             className="w-full border border-dashed border-gray-400 rounded-md px-5 py-6 flex items-center justify-between hover:bg-gray-50 transition"
//           >
//             <div className="flex items-center gap-5 text-left">
//               <div className="w-9 h-9 rounded-full border border-black flex items-center justify-center">
//                 <AddIcon sx={{ fontSize: 22 }} />
//               </div>

//               <div>
//                 <p className="font-semibold text-sm">Add New Address</p>
//                 <p className="text-sm text-gray-600 mt-1">
//                   Save a new address for faster checkout
//                 </p>
//               </div>
//             </div>
//           </button>

//           <div className="mt-6">
//             <h2 className="font-semibold text-sm mb-3">Saved Addresses</h2>

//             <div className="space-y-3">
//               {addresses.length > 0 ? (
//                 addresses.map((item: Address, index: number) => (
//                   <AddressCard
//                     key={item.id || index}
//                     item={item}
//                     selectedValue={value}
//                     value={index}
//                     handleChange={handleChange}
//                   />
//                 ))
//               ) : (
//                 <div className="border border-gray-200 rounded-md p-5 text-sm text-gray-500">
//                   No saved address found. Please add a new address.
//                 </div>
//               )}
//             </div>
//           </div>

//           <div className="mt-5">
//             <Button
//               onClick={() => navigate("/cart")}
//               variant="outlined"
//               startIcon={<ArrowBackIcon />}
//               sx={{
//                 color: "#111",
//                 borderColor: "#111",
//                 textTransform: "none",
//                 px: 3,
//                 py: 1.2,
//                 "&:hover": {
//                   borderColor: "#111",
//                   backgroundColor: "#f7f7f7",
//                 },
//               }}
//             >
//               Back to Cart
//             </Button>
//           </div>

//           <div className="border-t mt-5 pt-4 flex items-center gap-2 text-xs text-gray-600">
//             <LockIcon sx={{ fontSize: 16 }} />
//             <span>Your information is secure and will not be shared with anyone.</span>
//           </div>
//         </div>

//         <div className="lg:col-span-1">
//           <div className="border border-gray-200 rounded-md p-5 lg:sticky lg:top-24">
//             <h2 className="text-sm font-semibold mb-4">Order Summary</h2>

//             <PricingCard />

//             <div className="border-t border-gray-200 mt-4 pt-4 space-y-4">
//               <div className="flex gap-4">
//                 <SecurityIcon />
//                 <div>
//                   <p className="font-semibold text-sm">Secure Payments</p>
//                   <p className="text-xs text-gray-600">
//                     100% safe and secure checkout
//                   </p>
//                 </div>
//               </div>

//               <div className="border-t pt-4 flex gap-4">
//                 <Inventory2OutlinedIcon />
//                 <div>
//                   <p className="font-semibold text-sm">Easy Returns</p>
//                   <p className="text-xs text-gray-600">
//                     Hassle-free return policy
//                   </p>
//                 </div>
//               </div>

//               <div className="border-t pt-4 flex gap-4">
//                 <SupportAgentOutlinedIcon />
//                 <div>
//                   <p className="font-semibold text-sm">24/7 Support</p>
//                   <p className="text-xs text-gray-600">
//                     We’re here to help you anytime
//                   </p>
//                 </div>
//               </div>
//             </div>

//             <Button
//               onClick={handleCreateOrder}
//               disabled={addresses.length === 0}
//               variant="contained"
//               fullWidth
//               startIcon={<LockIcon />}
//               sx={{
//                 mt: 4,
//                 py: 1.4,
//                 bgcolor: "#2f2f35",
//                 textTransform: "none",
//                 fontWeight: 600,
//                 "&:hover": {
//                   bgcolor: "#1f1f24",
//                 },
//               }}
//             >
//               Checkout
//             </Button>

//             <Button
//               onClick={() => navigate("/")}
//               variant="outlined"
//               fullWidth
//               sx={{
//                 mt: 1.5,
//                 py: 1.3,
//                 color: "#111",
//                 borderColor: "#111",
//                 textTransform: "none",
//                 fontWeight: 600,
//                 "&:hover": {
//                   borderColor: "#111",
//                   backgroundColor: "#f7f7f7",
//                 },
//               }}
//             >
//               Continue to Shopping
//             </Button>
//           </div>
//         </div>
//       </div>

//       <Modal
//         open={open}
//         onClose={handleClose}
//         disableScrollLock
//         aria-labelledby="address-modal-title"
//         aria-describedby="address-modal-description"
//       >
//         <Box sx={style}>
//           <AddressForm
//             mode="checkout"
//             paymentGateway={paymentGateway}
//             handleClose={handleClose}
//             onAddressSubmit={handleAddressSubmit}
//           />
//         </Box>
//       </Modal>
//     </div>
//   );
// };

// export default AddressPage;




import React, { useEffect, useState } from "react";
import PricingCard from "../Cart/PricingCard";
import { Box, Button, Modal } from "@mui/material";
import AddressForm from "./AddresssForm";
import AddressCard from "./AddressCard";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LockIcon from "@mui/icons-material/Lock";
import SecurityIcon from "@mui/icons-material/Security";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import { useNavigate } from "react-router-dom";

import { createOrder } from "../../../Redux Toolkit/Customer/OrderSlice";
import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
import {
  addUserAddress,
  fetchUserAddresses,
} from "../../../Redux Toolkit/Customer/UserSlice";
import { Address } from "../../../types/userTypes";

const style = {
  position: "fixed" as const,
  top: "52%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "calc(100% - 24px)",
  maxWidth: "620px",
  outline: "none",
  bgcolor: "transparent",
  boxShadow: "none",
  p: 0,
  overflow: "hidden",
};

const getAddressKey = (address: Address, index: number) => {
  return address.id ? String(address.id) : `index-${index}`;
};

const AddressPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { user } = useAppSelector((store) => store);

  const addresses =
    user.addresses && user.addresses.length > 0
      ? user.addresses
      : user.user?.addresses || [];

  const [selectedAddressKey, setSelectedAddressKey] = useState<string>("");
  const [paymentGateway] = useState("RAZORPAY");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const jwt = localStorage.getItem("jwt") || "";

    if (jwt) {
      dispatch(fetchUserAddresses({ jwt }));
    }
  }, [dispatch]);

  useEffect(() => {
    if (addresses.length === 0) {
      setSelectedAddressKey("");
      return;
    }

    const selectedAddressStillExists = addresses.some(
      (address: Address, index: number) =>
        getAddressKey(address, index) === selectedAddressKey
    );

    if (selectedAddressStillExists) {
      return;
    }

    const defaultAddressIndex = addresses.findIndex(
      (address: Address) => address.defaultAddress
    );

    const initialIndex = defaultAddressIndex >= 0 ? defaultAddressIndex : 0;
    setSelectedAddressKey(getAddressKey(addresses[initialIndex], initialIndex));
  }, [addresses, selectedAddressKey]);

  const handleOpen = () => {
    setOpen(true);
    document.body.style.overflow = "hidden";
  };

  const handleClose = () => {
    setOpen(false);
    document.body.style.overflow = "";
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedAddressKey(event.target.value);
  };

  const handleCreateOrder = () => {
    const selectedAddress =
      addresses.find(
        (address: Address, index: number) =>
          getAddressKey(address, index) === selectedAddressKey
      ) || addresses[0];

    if (!selectedAddress) return;

    dispatch(
      createOrder({
        paymentGateway,
        address: selectedAddress,
        jwt: localStorage.getItem("jwt") || "",
      })
    );
  };

  const handleAddressSubmit = async (address: Address) => {
    const jwt = localStorage.getItem("jwt") || "";

    if (!jwt) return;

    const result = await dispatch(addUserAddress({ jwt, address }));
    await dispatch(fetchUserAddresses({ jwt }));

    const createdAddress = result.payload as Address | undefined;

    if (createdAddress?.id) {
      setSelectedAddressKey(String(createdAddress.id));
    }

    handleClose();
  };

  return (
    <div className="min-h-screen bg-white px-4 sm:px-8 lg:px-14 xl:px-20 py-7">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-[1500px] mx-auto">
        <div className="lg:col-span-2">
          <h1 className="text-lg font-semibold">Select Delivery Address</h1>

          <p className="text-sm text-gray-600 mt-1 mb-6">
            Choose an address to deliver your order
          </p>

          <button
            type="button"
            onClick={handleOpen}
            className="w-full border border-dashed border-gray-400 rounded-md px-5 py-6 flex items-center justify-between hover:bg-gray-50 transition"
          >
            <div className="flex items-center gap-5 text-left">
              <div className="w-9 h-9 rounded-full border border-black flex items-center justify-center">
                <AddIcon sx={{ fontSize: 22 }} />
              </div>

              <div>
                <p className="font-semibold text-sm">Add New Address</p>
                <p className="text-sm text-gray-600 mt-1">
                  Save a new address for faster checkout
                </p>
              </div>
            </div>
          </button>

          <div className="mt-6">
            <h2 className="font-semibold text-sm mb-3">Saved Addresses</h2>

            <div className="space-y-3">
              {addresses.length > 0 ? (
                addresses.map((item: Address, index: number) => {
                  const addressKey = getAddressKey(item, index);

                  return (
                    <AddressCard
                      key={addressKey}
                      item={item}
                      selectedValue={selectedAddressKey}
                      value={addressKey}
                      handleChange={handleChange}
                    />
                  );
                })
              ) : (
                <div className="border border-gray-200 rounded-md p-5 text-sm text-gray-500">
                  No saved address found. Please add a new address.
                </div>
              )}
            </div>
          </div>

          <div className="mt-5">
            <Button
              onClick={() => navigate("/cart")}
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              sx={{
                color: "#111",
                borderColor: "#111",
                textTransform: "none",
                px: 3,
                py: 1.2,
                "&:hover": {
                  borderColor: "#111",
                  backgroundColor: "#f7f7f7",
                },
              }}
            >
              Back to Cart
            </Button>
          </div>

          <div className="border-t mt-5 pt-4 flex items-center gap-2 text-xs text-gray-600">
            <LockIcon sx={{ fontSize: 16 }} />
            <span>Your information is secure and will not be shared with anyone.</span>
          </div>
        </div>

        <div className="lg:col-span-1">
          <div className="border border-gray-200 rounded-md p-5 lg:sticky lg:top-24">
            <h2 className="text-sm font-semibold mb-4">Order Summary</h2>

            <PricingCard />

            <div className="border-t border-gray-200 mt-4 pt-4 space-y-4">
              <div className="flex gap-4">
                <SecurityIcon />
                <div>
                  <p className="font-semibold text-sm">Secure Payments</p>
                  <p className="text-xs text-gray-600">
                    100% safe and secure checkout
                  </p>
                </div>
              </div>

              <div className="border-t pt-4 flex gap-4">
                <Inventory2OutlinedIcon />
                <div>
                  <p className="font-semibold text-sm">Easy Returns</p>
                  <p className="text-xs text-gray-600">
                    Hassle-free return policy
                  </p>
                </div>
              </div>

              <div className="border-t pt-4 flex gap-4">
                <SupportAgentOutlinedIcon />
                <div>
                  <p className="font-semibold text-sm">24/7 Support</p>
                  <p className="text-xs text-gray-600">
                    We’re here to help you anytime
                  </p>
                </div>
              </div>
            </div>

            <Button
              onClick={handleCreateOrder}
              disabled={addresses.length === 0}
              variant="contained"
              fullWidth
              startIcon={<LockIcon />}
              sx={{
                mt: 4,
                py: 1.4,
                bgcolor: "#2f2f35",
                textTransform: "none",
                fontWeight: 600,
                "&:hover": {
                  bgcolor: "#1f1f24",
                },
              }}
            >
              Checkout
            </Button>

            <Button
              onClick={() => navigate("/")}
              variant="outlined"
              fullWidth
              sx={{
                mt: 1.5,
                py: 1.3,
                color: "#111",
                borderColor: "#111",
                textTransform: "none",
                fontWeight: 600,
                "&:hover": {
                  borderColor: "#111",
                  backgroundColor: "#f7f7f7",
                },
              }}
            >
              Continue to Shopping
            </Button>
          </div>
        </div>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        disableScrollLock
        aria-labelledby="address-modal-title"
        aria-describedby="address-modal-description"
      >
        <Box sx={style}>
          <AddressForm
            mode="checkout"
            paymentGateway={paymentGateway}
            handleClose={handleClose}
            onAddressSubmit={handleAddressSubmit}
          />
        </Box>
      </Modal>
    </div>
  );
};

export default AddressPage;